import React from 'react';
import './Text.css';

function Text({
  variant = 'body',
  as = 'p',
  className = '',
  children,
  ...rest
}) {
  const Tag = as;
  const classes = ['ui-text', `ui-text--${variant}`, className].filter(Boolean).join(' ');

  return (
    <Tag className={classes} {...rest}>
      {children}
    </Tag>
  );
}

export default Text;
